module.exports = __webpack_public_path__ + "img/no-photo.5979bacb.svg";